import { Redirect, useHistory } from 'react-router-dom';
import { useSearchAtFeatureTabQuery } from '../../generated/graphql';
import { LoadingBox } from '../atoms/LoadingBox';
import AtSearchEventListVertical from '../molecules/AtSearchEventListVertical';
import { AtSearchNoResults } from '../atoms/AtSearchNoResults';
import style from './AtSearchFeatureList.module.scss';

interface AtSearchFeatureListProps {
  keyword: string;
  page: number;
  size: number;
}

export const AtSearchFeatureList = ({ keyword, page, size }: AtSearchFeatureListProps) => {

  const {
    loading, error, data, refetch,
  } = useSearchAtFeatureTabQuery({
    variables: { page, size, keyword },
  });

  const history = useHistory();

  const onPageChanged = (currentPage: number) => {

    history.push(`/search/feature?k=${keyword}&p=${currentPage}&s=${size}`);

  };

  const onSizeChanged = (currentSize: number) => {

    history.push(`/search/feature?k=${keyword}&p=1&s=${currentSize}`);

  };

  if (loading) {

    return <LoadingBox />;

  }

  if (error || !data?.searchTvFeatures) {

    return <Redirect to={{ pathname: '/500', state: { invalidURL: window.location.pathname } }} />;

  }

  const searchResults = data?.searchTvFeatures;

  return (
    <div className={` ${style.atSearchFeatureList} `}>
      {searchResults.content && searchResults.content.length > 0 && (
        <AtSearchEventListVertical
          refetch={refetch}
          page={page}
          size={size}
          tvEventPages={searchResults}
          onPageChanged={onPageChanged}
          onSizeChanged={onSizeChanged}
        />
      )}
      {(!searchResults.content || searchResults.content.length === 0) && <AtSearchNoResults />}
    </div>
  );

};

export default AtSearchFeatureList;
